import type { Ref } from "vue";

export type FetchStatus = "idle" | "pending" | "success" | "error";

export function useIsFetching(status: Ref<FetchStatus>) {
  return computed(() => status.value === "idle" || status.value === "pending");
}
